// Serialize the store into the planner v2 v4 payload. Store ids and hydrated
// image URLs are runtime values. The server resolves image URLs on each load.

export function toContent(state, { includeRuntimeImageUrls = false } = {}) {
  return {
    version: 4,
    view: { scale: state.view.scale, posX: state.view.posX, posY: state.view.posY },
    settings: state.settings,
    elements: state.elements.map(({ id, ...el }) => {
      if (el.type !== 'image' || includeRuntimeImageUrls) return el;
      const { url, ...data } = el.data || {};
      return { ...el, data };
    }),
    layers: state.layers,
  };
}

// Drafts stay in this browser, so retain hydrated image URLs for an immediate
// restore. Rails payloads must use `toContent`, which removes those URLs.
export function toDraftContent(state) {
  return toContent(state, { includeRuntimeImageUrls: true });
}

export function toPlanPayload(state) {
  return {
    plan: {
      content: toContent(state),
      name: state.settings?.name ?? state.name,
      access: state.settings?.access,
    },
  };
}

// A deep-cloned snapshot of the editable state for the undo stack.
export function snapshot(state) {
  return JSON.parse(JSON.stringify({
    elements: state.elements,
    layers: state.layers,
    settings: state.settings,
  }));
}
